import { createSelector } from '@reduxjs/toolkit';
import { getImmutableCompatible } from 'src/utils/immutableUtils';
import { name } from './slice';
import type { PreviousFiltersStore } from './types';

const getState = (state): PreviousFiltersStore =>
  getImmutableCompatible(state, name);

export const previousFiltersSelector = createSelector([getState], (state) =>
  getImmutableCompatible(state, 'filters'),
);

export const isSuggestedFiltersShownSelector = createSelector(
  [getState],
  (state) => state.isSuggestedFiltersShown,
);
